import { render, staticRenderFns } from "./FractionSwitch.vue?vue&type=template&id=5216a5b8"
import script from "./FractionSwitch.vue?vue&type=script&lang=js"
export * from "./FractionSwitch.vue?vue&type=script&lang=js"
import style0 from "./FractionSwitch.vue?vue&type=style&index=0&id=5216a5b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports